import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_sales_rep_tenant_order_list: { message: "idle" },
};

export const retrieve_sales_rep_tenant_order_list_Slice = createSlice({
 name: "retrieve_sales_rep_tenant_order_list",
 initialState,
 reducers: {
  success_retrieve_sales_rep_tenant_order_list: (state, action) => {
   state.retrieve_sales_rep_tenant_order_list = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_sales_rep_tenant_order_list: (state, action) => {
   state.retrieve_sales_rep_tenant_order_list = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_sales_rep_tenant_order_list: (state) => {
   state.retrieve_sales_rep_tenant_order_list = { status: app_consts.IDLE };
  },
  loading_retrieve_sales_rep_tenant_order_list: (state) => {
   state.retrieve_sales_rep_tenant_order_list = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_sales_rep_tenant_order_list, fail_retrieve_sales_rep_tenant_order_list, reset_retrieve_sales_rep_tenant_order_list, loading_retrieve_sales_rep_tenant_order_list } = retrieve_sales_rep_tenant_order_list_Slice.actions;

export default retrieve_sales_rep_tenant_order_list_Slice.reducer;